import { createContext, useContext } from 'react'
import {
  noopRoutingTelemetryReporter,
  type RoutingTelemetryReporter,
} from './routingTelemetryReporter'

export const RoutingTelemetryContext = createContext<RoutingTelemetryReporter>(
  noopRoutingTelemetryReporter,
)

/**
 * Read-handle to the routing telemetry reporter installed by the closest
 * `<RoutingController>`. Returns the no-op reporter when the controller
 * is not mounted. Variant-tap / card-dismiss consumers call the returned
 * function with the event payload; the cross-platform contract lives in
 * `wiki/01-products/metro-routing-events.md`.
 */
export function useRoutingTelemetry(): RoutingTelemetryReporter {
  return useContext(RoutingTelemetryContext)
}
